import { type ComponentType, type LazyExoticComponent, lazy } from 'react';

export type LazyComponentWithPreload<T extends ComponentType<any>> = {
  preload: () => Promise<{ default: T }>;
} & LazyExoticComponent<T>;

const lazyWithPreload = (
  factory: () => Promise<{ default: ComponentType<any> }>,
): LazyComponentWithPreload<ComponentType<any>> => {
  const Component = lazy(factory) as LazyComponentWithPreload<ComponentType<any>>;
  Component.preload = factory;
  return Component;
};

export const FlowEntry = lazyWithPreload(() => import('../../pages/FlowEntry'));
export const Lp1Welcome = lazyWithPreload(() => import('../../pages/Welcome/Lp1Welcome'));
export const StartChtOnb = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/start_cht_onb'),
);
export const PrcLctChtOnb = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/prc_lct_cht_onb'),
);
export const ZnAlrtCtnOnb = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/zn_alrt_ctn_onb'),
);
export const LcHsCtnOnb = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/lc_hs_ctn_onb'),
);
export const OnePagerCtnOnb = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_ctn_onb'),
);
export const ComboWelcome = lazyWithPreload(() => import('../../pages/WinCombo/ComboWelcome'));
export const OnePagerAllGn = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_all_gn'),
);
export const OnePagerKwtt = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_kwtt'),
);
export const OnePagerAllGnhdl = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_all_gnhdl'),
);
export const OnePagerAllUs = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_all_us'),
);
export const OnePagerAllDc = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_all_dc'),
);
export const OnePagerLf = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_lf'),
);
export const Map = lazyWithPreload(() => import('../../pages/Map'));
export const Signup = lazyWithPreload(() => import('../../pages/Signup'));
export const EmailConsent = lazyWithPreload(() => import('../../pages/EmailConsent'));
export const Checkout = lazyWithPreload(() => import('../../pages/Checkout'));
export const ComboFeatures = lazyWithPreload(() => import('../../pages/WinCombo/ComboFeatures'));
export const ComboMap = lazyWithPreload(() => import('../../pages/WinCombo/ComboMap'));
export const OnePagerAllWs = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_all_ws'),
);
export const ComboSignup = lazyWithPreload(() => import('../../pages/WinCombo/ComboSignup'));
export const SignupCtnOnb = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboSignup/SignupCtnOnb'),
);
export const SignupLf = lazyWithPreload(() => import('../../pages/WinCombo/ComboSignup/SignupLf'));
export const ComboCheckout = lazyWithPreload(() => import('../../pages/WinCombo/ComboCheckout'));
export const Paycheck2pr3hFastpay2 = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboCheckout/paycheck2_pr3_h_fastpay2'),
);
export const Paycheck2pr3hFastpay2Tp = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboCheckout/paycheck2_pr3_h_fastpay2_tp'),
);
export const Paycheck2pr3hPln = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboCheckout/paycheck2_pr3_h_pln'),
);
export const Paycheck2pr3hFastpayBm = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboCheckout/paycheck2_pr3_h_fastpay_bm'),
);
export const CheckoutCtnOnb = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboCheckout/checkout_ctn_onb'),
);
export const Paycheck2pr1wHAmUs = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboCheckout/paycheck2_pr1w_h_am_us'),
);
export const PaycheckParentalLg2 = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboCheckout/paycheck_parental_lg2'),
);
export const ComboUpsell = lazyWithPreload(() => import('../../pages/WinCombo/ComboUpsell'));
export const ComboUpsellTp = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboUpsell/upsell_an_private_tp'),
);
export const UpsellGuide = lazyWithPreload(() => import('../../pages/UpsellGuide'));
export const UpsellGuideTp = lazyWithPreload(
  () => import('../../pages/UpsellGuide/upsell_guide_tp'),
);
export const Success = lazyWithPreload(() => import('../../pages/WinCombo/ComboSuccess'));
export const UpsellTrcV1 = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboUpsell/upsell_trc/screens/upsell_trc_v1'),
);
export const UpsellTrcV2 = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboUpsell/upsell_trc/screens/upsell_trc_v2'),
);

export const AutoSignup = lazyWithPreload(() => import('../../pages/StripeTest/AutoSignup'));
export const LegalCheckout = lazyWithPreload(() => import('../../pages/StripeTest/LegalCheckout'));
